import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type ProgressBarProps = {
	totalCount: number;
	portionCount: number;
	isLast?: boolean;
	isClickable?: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Section = styled.div<{ isCollapsible?: boolean }>({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isCollapsible }) => (isCollapsible ? 'pointer' : 'default'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Summary = styled.span({
	display: 'flex',
	alignItems: 'center',

	color: token('color.text.subtlest'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	width: '100%',
	display: 'flex',
	paddingTop: token('space.100'),
	paddingRight: 0,
	paddingBottom: token('space.100'),
	paddingLeft: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProgressBarContainer = styled.div({
	minWidth: '24px',
	marginRight: token('space.025'),
	display: 'flex',
	alignItems: 'stretch',
	flex: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProgressBarElementContainer = styled.button<ProgressBarProps>({
	minWidth: token('space.300'),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginRight: ({ isLast }) => (isLast ? token('space.0') : token('space.025')),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'stretch',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	flexGrow: ({ totalCount, portionCount }: ProgressBarProps) =>
		totalCount === 0 ? 1 : (portionCount / totalCount) * 100,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:hover > div:last-child': {
		transform: 'scaleY(1.5)',
		transition: 'all 0.1s ease-in-out',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isClickable }) => (isClickable ? 'pointer' : 'default'),
	containerType: 'inline-size',
	background: 'none',
	color: 'inherit',
	border: 'none',
	padding: 0,
	font: 'inherit',
	outline: 'inherit',
});

type BarProps = {
	color: string;
	isLast?: boolean;
	isFirst?: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Bar = styled.div<BarProps>({
	height: '8px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ color }: BarProps) => color,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderRadius: ({ isLast, isFirst }: BarProps) =>
		// eslint-disable-next-line no-nested-ternary -- https://compiledcssinjs.com/docs/limitations#returning-static-values-from-a-dynamic-property
		isFirst && isLast
			? token('radius.large')
			: // eslint-disable-next-line no-nested-ternary
				isFirst
				? `${token('radius.large')} 0 0 ${token('radius.large')}`
				: isLast
					? `0 ${token('radius.large')} ${token('radius.large')} 0`
					: 0,
});
